<template>
    <div>
        <empresa></empresa>
        <!-- <historia></historia> -->
    </div>
</template>

<script>

import Empresa from '../Empresa'
import Historia from '../Historia'

export default {
    components: {
        'empresa': Empresa,
        'historia': Historia
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaEmpresa.vue